import { Box, makeStyles } from "@material-ui/core";
import Typography from "app/liveShopping/backoffice/otm/components/reusables/Typography";
import { useFormik } from "formik";
import React from "react";
import { _t } from "utilities/i18n";
import { isEmpty } from "lodash-es";
import emitter from "utilities/emitter";
import { EVENT_FLASH_ERROR } from "utilities/emitter/events";
import { useBackgroundManager } from "app/liveShopping/backoffice/otm/hooks/backgroundHooks";
import Dropzone from "../../components/reusables/Dropzone";
import { Image } from "react-bootstrap-icons";

const useStyles = makeStyles((theme) => ({
  dropzones: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    marginBottom: "10px",
  },
  dropzoneBox: {
    textAlign: "center",
  },
  typoDrop: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "130%",
    marginBottom: "5px",
  },
  image: {
    width: "112px",
    height: "187px",
    borderRadius: "12px",
    background: (props) => (props.backgroundImage ? `url("${props.backgroundImage}")` : "none"),
    backgroundSize: "cover !important",
    backgroundRepeat: "no-repeat !important",
    backgroundPosition: "center !important",
  },
  remove: {
    fontSize: "10px",
    color: theme.palette.colors.grey700,
    textDecoration: "underline",
    cursor: "pointer",
    marginTop: "10px",
  },
}));
const CoverUpload = ({ wiz }) => {
  const classes = useStyles({ backgroundImage: wiz?.theme?.background_image });
  const handleManageBackground = useBackgroundManager();

  const handleAddingImage = (background_image) => {
    handleManageBackground({
      action: "add",
      keyword: wiz.keyword,
      media: background_image,
      errorCallback: () => emitter.emit(EVENT_FLASH_ERROR, _t("Cannot upload the background file")),
      callback: () => { },
    });
  };

  const onRemoveBgImage = () => {
    handleManageBackground({
      action: "delete",
      keyword: wiz?.keyword,
    });
  };

  const formik = useFormik({
    initialValues: {
      background_image: wiz?.theme.picture_url || null,
    },
  });

  return (
    <Box style={{ textAlign: "center" }}>
      <Typography variant={"bodySB13"} className={classes.typoDrop}>
        {_t("Cover Image")}
      </Typography>

      {!wiz?.theme?.background_image && (
        <Dropzone
          isLoading={formik.isSubmitting}
          availableFormats={["image/jpeg", "image/png"]}
          isSmall
          multiple={false}
          title={<Box className={classes.title}>{_t("Add")}</Box>}
          instruction={_t("900x1600px (ratio 9:16), 2Mo max.")}
          disabled={false}
          icon={Image}
          onDrop={(file) => handleAddingImage(file)}
          error={!isEmpty(formik.errors?.errorUpload) && formik.errors.errorUpload}
        />
      )}

      {wiz?.theme?.background_image && (
        <>
          <Box className={classes.image} />
          <Box className={classes.remove} onClick={onRemoveBgImage}>
            {_t("Remove / Change")}
          </Box>
        </>
      )}
    </Box>
  );
};

export default CoverUpload;
